"use client";

import { ProductTile } from "@/components/productTile/productTile.component";
import { ProductTileQuantityStepper } from "@/components/productTile/productTileQuantityStepper.component";
import { Text } from "@/components/text/text.component";

import { addAccessoryToTemporaryCart } from "@/app/blu/shop/[slug]/actions";
import { type CategoryProducts } from "@/app/blu/shop/actions";
import { useConfiguratorInteractionEvent } from "@/hooks/useConfiguratorInteractionEvent";
import type { GetProductQueryResult } from "@/sanity.types";

export const ProductAccessoriesProducts = ({
  kit,
  products,
  basketItems = {},
  pending,
}: ProductAccessoriesProductsProps) => {
  const fireConfiguratorEvent = useConfiguratorInteractionEvent();
  if (!products?.length) return null;
  const renderProducts = () => {
    if (pending) {
      return [...Array(3)].map((_, index) => (
        <li
          data-testid="product-accessories-products-list-loading-item"
          key={index}>
          <ProductTile loading product={{ slug: "/blu/shop/product-slug" }} />
        </li>
      ));
    }
    return products.map((product, index) => {
      if (!product) return null;
      const isIncluded = kit?.bundledProducts?.find((bundledProduct) => {
        return bundledProduct?.product?.id == product.id;
      });
      return (
        <li
          data-testid="product-accessories-products-list-item"
          key={product?.id || `accessory-${index}`}>
          <ProductTile product={product} viewDetails>
            <div className="flex flex-col gap-2 py-4 md:flex-row md:items-center md:gap-4">
              <ProductTileQuantityStepper
                basketItems={basketItems}
                id={product?.id}
                formAction={addAccessoryToTemporaryCart}
                onInteraction={(action) =>
                  fireConfiguratorEvent(action, product?.name)
                }
              />
              {isIncluded ? (
                <Text>{isIncluded.quantity ?? 1} included</Text>
              ) : null}
            </div>
          </ProductTile>
        </li>
      );
    });
  };
  return (
    <section data-testid="product-accessories-products">
      <ul
        data-testid="product-accessories-products-list"
        className="grid grid-cols-2 gap-6 lg:grid-cols-4">
        {renderProducts()}
      </ul>
    </section>
  );
};

export type ProductAccessoriesProductsProps = {
  kit: GetProductQueryResult;
  products: CategoryProducts;
  basketItems?: Record<string, number>;
  pending: boolean;
};
